import TaskColumn from './TaskColumn'

export default TaskColumn.extend({
  name: 'RecentlyCompletedTaskColumn',
  methods: {
    canReorder(sourceContainerOptions : any, payload: any) {
      const taskUserId = (this as any).$store.state.task.userIdInFocus;
      const loggedInUser = (this as any).$store.state.user.appUserId;
      if (!(this as any).acceptDrop || taskUserId !== loggedInUser) {
        return false;
      }
      return !payload.assignedToSecurityRoleId && payload.isRead;
    },
  }
});



// WEBPACK FOOTER //
// ./node_modules/tslint-loader??ref--0!./src/componentsReusable/tasks/column/RecentlyCompletedTaskColumn.ts